/**
 * @description Determines the system code based on the registration source (rs) parameter.
 * The mapping is as follows:
 * - If rs is 'qrcode', return 'DandG_QRR'
 * - If rs is 'photoregister', return 'DandG_PPR'
 * - For any other value of rs (including undefined), return 'DandG_IPR'
 *
 * See image in https://domgen.atlassian.net/browse/UEO-785
 *
 * @param {string | undefined}  rs - The registration source parameter from the URL
 * @return {string} - The corresponding system code based on the mapping rules
 * @example
 *
 * ````typescript
 * getSystemCode('qrcode'); // returns 'DandG_QRR'
 * getSystemCode('photoregister'); // returns 'DandG_PPR'
 * getSystemCode('someOtherValue'); // returns 'DandG_IPR'
 * ````
 */
export function getSystemCode(rs?: string) {
  if (rs === 'qrcode') return 'DandG_QRR';
  if (rs === 'photoregister') return 'DandG_PPR';
  return 'DandG_IPR';
}
